import { ReactNode } from 'react'
import { Grid, styled } from '@mui/material'

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  margin: '0 auto',
  position: 'relative',
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),

  '&:not(.fullWidth)': {
    maxWidth: theme.spacing(57.5),

    [theme.breakpoints.up('sm')]: {
      maxWidth: theme.spacing(101),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: theme.spacing(134)
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      maxWidth: theme.spacing(179)
    }
  }
}))

export default function BasicPageContainer({
  tight,
  children,
  className
}: {
  tight?: boolean
  children?: ReactNode
  className?: string
}) {
  return (
    <Root className={className}>
      {tight ? (
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={10}>
            {children}
          </Grid>
        </Grid>
      ) : (
        children
      )}
    </Root>
  )
}
